import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import DLL from '@visma/formula/lib/dll';

import { USER } from '../../data/reducer';
import { withPageBase } from '../../components/PageBase';
import { selectIsHpa } from '../../data/hpa/selectors';
import { UserInfoRequestCard } from './components/userInfoRequestCard';
import { ViksuConnectionError } from './ViksuConnectionError';
import { HpaAccessDenied } from './hpaAlert';
import {
  checkViksuHealth,
  serviceStatus,
} from '../../data/user/userInfoRequests/actions';
import {OTLink} from "../../components/tag/OTLink";

const { id: module_id } = module;

const SendUserInfoRequest = ({
  userInfoRequestState,
  checkViksuHealth,
  isHpa,
}) => {
  const { viksuStatus } = userInfoRequestState;
  const forms = DLL.useForms({ status: 'published' });
  const [filteredForms, setFilteredForms] = useState([]);

  useEffect(() => {
    if (viksuStatus === serviceStatus.OFFLINE) {
      checkViksuHealth();
    }
  }, [viksuStatus, checkViksuHealth]);

  useEffect(() => {
    forms.filter((form) =>
        form.tags.find((elm) => elm.toLowerCase() === 'tietopyynto')
    );
    setFilteredForms(
      forms.sort(function(a, b) {
        return a.meta.orderPriority - b.meta.orderPriority
      })
    );
  }, [setFilteredForms]);

  return isHpa ? (
    <HpaAccessDenied />
  ) : (
    <>
      {viksuStatus === serviceStatus.FAILED && <ViksuConnectionError />}
      <p>
        <FormattedMessage id={`${module_id}.list.description`} />
      </p>
      {filteredForms.map((form) => (
          <UserInfoRequestCard
            key={form._id}
            form={form}
            link={`/userinforequest/${form._id}`}
          />
      ))}
    </>
  );
};

const userInfoRequestBackButton = (
    <OTLink to={'/userInfo'}>
      <FormattedMessage id={`${module_id}.back`} />
    </OTLink>
);

const mapStateToProps = (state) => {
  return {
    userInfoRequestState: state[USER].userInfoRequests,
    isHpa: selectIsHpa(state),
  };
};

export default withPageBase(
  connect(mapStateToProps, {
    checkViksuHealth,
  })(SendUserInfoRequest),
  {
    title: `${module_id}.title`,
    backButton: userInfoRequestBackButton
  }
);
